import { envConfig } from '@/config/env'
import { resolveViteRouterBasename } from '@/utils/appBase'

const trimTrailingSlash = (value: string): string => value.replace(/\/+$/, '')

export const resolveAuthPortalBaseUrl = (): string => {
  const configured = String(envConfig.authPortalBaseUrl || '/auth/').trim() || '/auth/'

  if (configured.startsWith('http://') || configured.startsWith('https://')) {
    return trimTrailingSlash(configured)
  }

  if (typeof window === 'undefined') {
    return trimTrailingSlash(configured)
  }

  const normalizedPath = configured.startsWith('/') ? configured : `/${configured}`
  return `${window.location.origin}${trimTrailingSlash(normalizedPath)}`
}

export const buildAppReturnPath = (pathname: string, search = '', hash = ''): string => {
  const basename = resolveViteRouterBasename() || ''
  const normalizedPath = pathname.startsWith('/') ? pathname : `/${pathname}`

  if (!basename) {
    return `${normalizedPath}${search}${hash}`
  }

  if (normalizedPath === basename || normalizedPath.startsWith(`${basename}/`)) {
    return `${normalizedPath}${search}${hash}`
  }

  return `${basename}${normalizedPath}${search}${hash}`
}

export const buildAuthPortalLoginUrl = (returnPath: string): string => {
  const authBase = resolveAuthPortalBaseUrl()
  const normalizedReturn = returnPath.startsWith('/') ? returnPath : `/${returnPath}`
  return `${authBase}/?next=${encodeURIComponent(normalizedReturn)}`
}

export const redirectToAuthPortal = (returnPath: string): void => {
  if (typeof window === 'undefined') {
    return
  }

  window.location.assign(buildAuthPortalLoginUrl(returnPath))
}
